import {
  useOriginalData,
  useProcessedData,
} from "@/stores/data-processing";
import { useActiveDataflow } from "@/stores/dataflow";
import { useMemo } from "react";

/**
 * Hook to get available column names from the data
 * @deprecated
 */
export function useDataSourceColumns(_transformerIndex?: number): string[] {
  const activeDataflow = useActiveDataflow();
  const activeDataflowId = activeDataflow?.dataflow_id || "";
  const processedData = useProcessedData(activeDataflowId || "");
  const originalData = useOriginalData(activeDataflowId || "");

  const columns = useMemo(() => {
    if (processedData?.metadata?.columns) {
      return processedData.metadata.columns;
    }

    if (originalData && originalData.length > 0) {
      const firstRow = originalData[0];
      if (firstRow && typeof firstRow === "object") {
        return Object.keys(firstRow);
      }
    }

    return [];
  }, [processedData, originalData]);

  return columns;
}
